import { ChannelName } from '../services/service';

export const PKCE = {
  DEFAULT_PKCE_LENGTH: 48,
  MAX_PKCE_LENGTH: 128,
  MIN_PKCE_LENGTH: 43,
};

export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
}

export enum LoggerNames {
  AUTH_STATE_MANAGER = 'MapSSO AuthStateManager',
  FETCH = 'MapSSO Fetch',
  MAP_SSO = 'MapSSO',
  OIDC_CONFIG_MANAGER = 'MapSSO OidcConfigManager',
  PKCE_MANAGER = 'MapSSO PkceManager',
  ROUTER = 'MapSSO Router',
  STATE_VERIFIER = 'MapSSO StateVerifier',
  TOKEN_MANAGER = 'MapSSO TokenManager',
  STORAGE_UTILS = 'MapSSO StorageUtils',
  LEADER_ELECTION = 'MapSSO LeaderElection Service',
  AUTO_RENEWAL = 'MapSSO AutoRenewal Service',
  SERVICE_MANAGER = 'MapSSO ServiceManager',
  SYNC_STORAGE = 'MapSSO SyncStorage Service',
  SINGLE_SIGN_OUT = 'MapSSO Single Sign Out Service',
  AUTHN = 'MapSSO Authn',
  TRANSACTION_MANAGER = 'MapSSO TransactionManager',
  AUTH_STATE_SERVICE = 'MapSSO Auth State Service',
}

export const DEFAULT_EXPIRES_EARLY_WARNING = 60 * 1000 * 10; // 10 minutes

export const CLOCK_SKEW = 1000 * 60; // 1 minute. Used to account for clock skew between client and server

export const CHANNEL_NAMES = {
  LEADER_ELECTION: 'map-sso:leader-election',
  SYNC_STORAGE: 'map-sso:sync-storage',
} satisfies Record<string, ChannelName>;
